import React from 'react';
import PropTypes from 'prop-types';
import MediumEditor from 'medium-editor';

import ErrorBoundary from '../../../../shared/error-boundary';
import Loading from '../../../../shared/loading';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import debounceAction from '../../../../shared/debounce-action';
import { updateTitle } from '../../../../services/wire/edit-services';
import Validator from '../../../../shared/validator';
import { editorValidate } from '../channel-editor-postal';

export default class Title extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      titleRequired: () => {
        const title = this.editor && this.editor.getContent();
        return title && title.trim().length;
      },
    });
    this.state = {
      title: this.props.value || '',
      initialTitle: this.props.value || '',
      validations: this.validator.getValidations(),
    };

    editorValidate(this, 'title');
    editorValidate(this, 'title', { topic: 'validate.title' });

    this.saveTitle = debounceAction({
      getCurrentValue: () => this.state.title,
      actionPromise: () => updateTitle(this.props.wireId, this.state.title),
      onBeforeAction: () => this.loading.start(),
      onError: e => defaultOnErrorHandler(e, 'Error saving title'),
      onAfterAction: () => this.loading.stop(),
      wait: 2000,
    });
    this.setNextFocusOnEnter = this.setNextFocusOnEnter.bind(this);
  }

  componentDidMount() {
    this.editor = new MediumEditor('.wire-editor-title', {
      imageDragging: false,
      disableReturn: true,
      toolbar: false,
      placeholder: {
        text: 'Type your headline here',
        hideOnClick: false,
      },
    });
    this.editor.subscribe('editableInput', () => {
      this.setState(state => {
        state.title = this.editor.getContent();
        state.validations = this.validator.validateForm(state);
        return state;
      }, this.saveTitle);
    });

    this.titleInput.focus();
  }

  setNextFocusOnEnter(el) {
    this.editor.subscribe('editableKeydownEnter', () => $(el).focus());
  }

  render() {
    return (
      <ErrorBoundary>
        <div className={`wire-title-container ${this.state.validations.formValid ? '' : 'has-error'}`}>
          <h2
            className="wire-editor-title"
            ref={el => (this.titleInput = el)}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: this.state.initialTitle,
            }}
          />
          <p className="sip-controls">
            <Loading variant="sip" ref={el => (this.loading = el)} />
          </p>
        </div>
        {!!this.state.validations.titleRequiredValid || <span className="help-block">Please create a headline for your wire.</span>}
      </ErrorBoundary>
    );
  }
}
